/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_Five_FramesInputs */



/**
* | output |
* | --- |
* | "Reverse 5 Frame" |
*
* @param {Shortcut_Keys_Name_Reverse_Five_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_five_frames = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_Five_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_Five_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer de 5 images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückwärts-5-Bild")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inverti 5 Frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратная сторона 5-кадровой рамки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marco 5 inverso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("反向5帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リバース5フレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवर्स 5 फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro reverso 5")
	return /** @type {LocalizedString} */ ("Reverse 5 Frame")
});